import { ButtonPrimary } from "components/Atoms/Button";
import React from "react";

interface Props {
  downloadFileUrl: string
}

export const DownloadInvoiceButton = (props: Props) => {
  return <ButtonPrimary
    iconLeft="icon-download"
    label={RESX.InvoiceDocument.DownloadInvoice}
    href={`${props.downloadFileUrl}?inline=false`}
  />
}